<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="title"
    :items="classes"
    item-value="id"
    @change="onChange"
    return-object
    v-on:input="$emit('input', $event)"
    auto-select-first
    :loading="loading"
    clearable
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import { Class } from '@/plugins/api'
import get from 'lodash-es/get'

export default {
  data: () => ({
    classes: [],
    loading: false,
  }),
  props: {
    filter: Object,
    defaultClasses: Array,
    type: String,
    changeClass: {
      type: Boolean,
      default: false,
    },
    currentClass: null,
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds', 'profile', 'role']),
  },
  created() {
    this.classes = this.defaultClasses || []
    this.fetchClass()
  },
  methods: {
    async fetchClass() {
      this.loading = true
      let params = {
        ...this.filter,
        status: 'running',
      }
      if (this.type === 'administrative') {
        params.type = 'administrative'
      } else {
        params.type = 'coreCurriculum'
      }
      this.classes = await Class.getSimpleClasses(params)
      if (this.changeClass && this.currentClass) {
        let classes = this.classes.filter((c) => get(c.grade, 'id') === this.currentClass.grade)
        classes = this.classes.filter((c) => c.id !== this.currentClass.id)
        this.classes = classes
      }
      this.loading = false
    },
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filter() {
      this.fetchClass()
    },
    currentClass() {
      this.fetchClass()
    },
  },
}
</script>
